import { __decorate } from "tslib";
import { Component, Ref, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import ApiBlockedUsers from "@/api/ApiBlockedUsers";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import DataBlockedUsers from "@/data/CMS/DataBlockedUsers";
import dayjs from "dayjs";
// Il backend salva il numero in forma canonica +39...; nel form il +39 e' un prefisso fisso.
function PhoneWithoutPrefix(phone) {
    return (phone || "").replace(/^\+39/, "");
}
let BlockedUsers = class BlockedUsers extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataBlockedUsers.Breadcrumbs;
        this.TableHeaders = DataBlockedUsers.TableHeaders;
        this.TableItems = [];
        this.search = "";
        this.isOpenDialog = false;
        this.isOpenEditDialog = false;
        this.HasLoading = false;
        this.newItem = {
            email: "",
            fiscalCode: "",
            phone: "",
        };
        this.currentItem = {
            uuid: "",
            email: "",
            fiscalCode: "",
            phone: "",
            create_at: "",
            update_at: "",
        };
    }
    // Ricerca locale: righe con email, codice fiscale o telefono che contengono il testo (case-insensitive).
    get FilteredItems() {
        const term = (this.search || "").trim().toLowerCase();
        if (!term) {
            return this.TableItems;
        }
        return this.TableItems.filter(item => (item.email || "").toLowerCase().includes(term) || (item.fiscalCode || "").toLowerCase().includes(term) ||
            (item.phone || "").includes(term));
    }
    openCreateDialog() {
        this.newItem = { email: "", fiscalCode: "", phone: "" };
        this.isOpenDialog = true;
    }
    closeCreateDialog() {
        this.isOpenDialog = false;
    }
    closeEditDialog() {
        this.isOpenEditDialog = false;
    }
    async openEditDialog(item) {
        try {
            const details = await ApiBlockedUsers.GetDetails(ApiEnter.CurrentSessionUUID, item.uuid);
            if (details) {
                this.currentItem = {
                    uuid: details.uuid,
                    email: details.email || "",
                    fiscalCode: details.fiscalCode || "",
                    phone: PhoneWithoutPrefix(details.phone),
                    create_at: details.create_at ? dayjs.tz(details.create_at, "Europe/Rome").format("DD.MM.YYYY HH:mm:ss") : "",
                    update_at: details.update_at ? dayjs.tz(details.update_at, "Europe/Rome").format("DD.MM.YYYY HH:mm:ss") : "",
                };
            }
            else {
                this.currentItem = {
                    uuid: item.uuid,
                    email: item.email || "",
                    fiscalCode: item.fiscalCode || "",
                    phone: PhoneWithoutPrefix(item.phone),
                    create_at: "",
                    update_at: "",
                };
            }
        }
        catch (e) {
            this.currentItem = {
                uuid: item.uuid,
                email: item.email || "",
                fiscalCode: item.fiscalCode || "",
                phone: PhoneWithoutPrefix(item.phone),
                create_at: "",
                update_at: "",
            };
        }
        this.isOpenEditDialog = true;
    }
    async CreateBlockedUser() {
        if (!this.newItem.email && !this.newItem.fiscalCode && !this.newItem.phone) {
            return;
        }
        this.HasLoading = true;
        try {
            const response = await ApiBlockedUsers.Create(ApiEnter.CurrentSessionUUID, this.newItem.email || undefined, this.newItem.fiscalCode || undefined, this.newItem.phone || undefined);
            if (response) {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_created"),
                    icon: "success",
                });
                this.closeCreateDialog();
                await this.GetList();
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
        this.HasLoading = false;
    }
    async UpdateBlockedUser() {
        if (!this.currentItem.email && !this.currentItem.fiscalCode && !this.currentItem.phone) {
            return;
        }
        this.HasLoading = true;
        try {
            const response = await ApiBlockedUsers.Update(ApiEnter.CurrentSessionUUID, this.currentItem.uuid, this.currentItem.email || undefined, this.currentItem.fiscalCode || undefined, this.currentItem.phone || undefined);
            if (response) {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                });
                this.closeEditDialog();
                await this.GetList();
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
        this.HasLoading = false;
    }
    DeleteBlockedUser(uuid) {
        sweetalert({
            title: this.$t("general.confirm"),
            text: "Do you really want to delete it?",
            icon: "warning",
            buttons: [this.$t("general.no"), this.$t("general.yes")],
        }).then(async (isConfirm) => {
            if (isConfirm === true) {
                const response = await ApiBlockedUsers.Delete(ApiEnter.CurrentSessionUUID, uuid);
                if (response) {
                    sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success",
                    });
                    this.GetList();
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
        });
    }
    async GetList() {
        try {
            const result = await ApiBlockedUsers.GetList(ApiEnter.CurrentSessionUUID);
            this.TableItems = result || [];
        }
        catch (e) {
            console.error(e);
            this.TableItems = [];
        }
    }
    created() {
        this.GetList();
    }
};
__decorate([
    Ref("new-form")
], BlockedUsers.prototype, "NewFormValidate", void 0);
BlockedUsers = __decorate([
    Component({
        components: { PageHeader, StandartTemplate },
    })
], BlockedUsers);
export default BlockedUsers;
